import { fetchAuthSession as amplifyFetchAuthSession } from 'aws-amplify/auth'
import { MissingTokenError } from '@einwert/valuation-api-client'

async function fetchAuthSession() {
    return amplifyFetchAuthSession()
}

export async function getAccessToken(): Promise<string> {
    const session = await fetchAuthSession()
    const token = session?.tokens?.accessToken
    if (!token) {
        throw new MissingTokenError()
    }
    return token.toString()
}
